export const TAB_TYPE_SIMPLE = 'simple';
export const TAB_TYPE_ROUNDED = 'rounded';
export const TAB_TYPE_SQUARED = 'squared';

export type TabTypeEnabledBackground = typeof TAB_TYPE_SQUARED;
export type TabTypeDisabledBackground = typeof TAB_TYPE_SIMPLE | typeof TAB_TYPE_ROUNDED;

export const ROUNDED_TAB_BLACK_VARIANT = 'black';
export const ROUNDED_TAB_GREY_VARIANT = 'grey';
export const ROUNDED_TAB_WHITE_VARIANT = 'white';

export interface Tab {
  name: string;
  id: string;
  href?: string;
}

export interface SimpleTabsProps {
  tabs: Tab[];
  onChange: (activeTab: string) => void;
  activeTab: string;
}

export interface RoundedTabsProps extends SimpleTabsProps {
  variant?: typeof ROUNDED_TAB_BLACK_VARIANT | typeof ROUNDED_TAB_GREY_VARIANT | typeof ROUNDED_TAB_WHITE_VARIANT;
}

export interface SquaredTabsProps extends SimpleTabsProps {
  showBackground: boolean;
}

export interface TabContentProps extends SimpleTabsProps {
  type: TabTypeEnabledBackground | TabTypeDisabledBackground;
  showBackground: boolean;
  secondary?: boolean;
  tabColor?: string;
  roundedVariant?: RoundedTabsProps['variant'];
}

export interface SquaredTabProps {
  name: string;
  id: string;
  activeTab: string;
  showBackground: boolean;
  onChange: (id: string) => void;
}

interface CommonProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (activeTab: string) => void;
  className?: string;
  paddingClasses?: string;
  secondary?: boolean;
  tabColor?: string;
  scrollable?: boolean;
  roundedVariant?: RoundedTabsProps['variant'];
}

type ConditionalProps =
  | {
      type?: TabTypeDisabledBackground;
      showBackground?: never;
    }
  | {
      type?: TabTypeEnabledBackground;
      showBackground: boolean;
    }
  | {
      type?: typeof TAB_TYPE_ROUNDED;
      showBackground: boolean;
    };

export type TabProps = CommonProps & ConditionalProps;
